import React ,{useEffect, useState } from "react";
import { Card, Accordion,Form,InputGroup, Row, Col } from "react-bootstrap";
import AddIndicatorView from "./AddIndicatorView";
import SliderView from "./SliderView";
import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import StopLossView from "./stoploss/StopLossView";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  CHANGE_MIN_TP,
  CHANGE_TAKE_PROFIT,
  CLOSE_DEAL_END_OF_TRADING_DAY,
  SET_CLOSE_AFTER_DEAL,
  SET_STOP_AFTER_DEAL,
  TRIGGER_DAISY_BOT
} from "../../../actions/create-bot-type";
import { BotType, PremiumBot } from "../../../Const";
import TakeProfitView from "./takeprofit/TakeProfitView";
import LeftRightForm from "./modules/LeftRightForm";
import CustomCheckbox from "./modules/CustomCheckbox";
import AutoClosePosEndOfTheDay from "./modules/AutoClosePosEndOfTheDay";

const ExitConditionsView = (props) => {
  const { newBot,t ,editing} = props;
  const maxVal = 100
  const isPremiumBot = PremiumBot[newBot.botType];
  const dispatch = useDispatch();
  const closeBotAfterDeal = newBot.closeBotAfterDeal;
  const stopBotAfterDeal = newBot.stopBotAfterDeal?true:false;
  const daisyBots = useSelector((state) => state.bots.daisyBots)||[];
  const daisyChain = newBot.daisyChain;
  const triggerBotDaisyChainId = newBot.triggerBotDaisyChain;
  const triggerBotDaisyChain = (daisyBots && triggerBotDaisyChainId) && daisyBots.find(
    (el) => el.id == triggerBotDaisyChainId 
  );
  const handleSelectDaisyBot = (bot) => {
    dispatch({
      type: TRIGGER_DAISY_BOT,
      payload: bot.value,
    });
  };
  useEffect(()=>{
    if(!editing && daisyChain==1 && daisyBots[0])
    {
        dispatch({
          type: TRIGGER_DAISY_BOT,
          payload: daisyBots[0].id,
        });
    }
  },[daisyChain])
 
  const setDealCloseValue = (val) => {
    dispatch({
      type: SET_CLOSE_AFTER_DEAL,
      payload: val,
    });
  };

  const minTpChanged = (val) => {
    if(val > maxVal)
    return
    dispatch({
      type: CHANGE_MIN_TP,
      payload: val,
    });
  };
  const selectedTriggerBot = {
    value: triggerBotDaisyChain ? triggerBotDaisyChain.id : daisyBots[0] && daisyBots[0].id,
    label: triggerBotDaisyChain ? triggerBotDaisyChain.name : daisyBots[0] && daisyBots[0].name,
  };
  const daisyBotItems =
    (daisyBots &&
      daisyBots.map((item) => ({
        value: item.id,
        label: item.name,
      }))) ||
    [];
  const setDealStopValue = (val) => {
    dispatch({
      type: SET_STOP_AFTER_DEAL,
      payload: val?1:0,
    });
  };
 
  const formatTakeProfit = (value) => (value == 0 ? t("disable") : `${value}%`);
  const formatDecimal = (value,decimals) => parseFloat(Number(value).toFixed(decimals));
  return (
    <>
      
            {daisyChain==1 && 
            <LeftRightForm
              left={<h6 className="bot-asset-tour">
              {t("trigger-daisy-bot")}
            </h6>}
              right={ <Select
                value={selectedTriggerBot}
                options={daisyBotItems}
                onChange={handleSelectDaisyBot}
                classNamePrefix='react-select'
              />}
            >
            </LeftRightForm>
            }
            <TakeProfitView t={t}></TakeProfitView>
            <StopLossView t={t}/>
            <AddIndicatorView newBot={newBot} isEntry={false} t={t}/>
            {isPremiumBot && (
              <>
                <SliderView
                  title={t("min-profit-indiactor")}
                  step={0.5}
                  min={0}
                  max={maxVal}
                  value={formatDecimal(newBot.minTp,2)}
                  onChange={minTpChanged}
                  formatLabel={formatTakeProfit}
                  hideLabel={true}
                  withInput={true}
                />
                <LeftRightForm
                left={<h6>{t("d-bot-if-stoploss")}</h6>}
                right={<div className="d-flex align-items-center">
                  <div><input
                      type="text"
                      className="input-text input-gp-tex dca-subseq-text small"
                      value={closeBotAfterDeal}
                      onChange={(e) => setDealCloseValue(e.target.value)}
                    /> </div>
                  <div className="ba-asset-left"><h6>in a row.</h6></div>
                  
                </div>}
                >
                </LeftRightForm>
                 
                </>
            )}
             <CustomCheckbox 
                    val={stopBotAfterDeal} 
                    checked={stopBotAfterDeal} 
                    callback={setDealStopValue}
                    label={t("stop-bot-after-deal-ends")}
                    id={'stop-bot-after-deal-ends'}
                    >
                </CustomCheckbox>
                 <AutoClosePosEndOfTheDay></AutoClosePosEndOfTheDay>
                
    </>
  );
};

export default ExitConditionsView;
